module.exports = __webpack_public_path__ + "static/media/Logo.4ef6bd72.svg";